import { Link, useLocation } from "react-router-dom";

import { IMAGES } from "../../constant/theme";
import { useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import { getCoachAttendance } from "../../../services/academicService";
import { formatHoursMinutes } from "../../../utils/helperFunction";

const AboutCoach = () => {
  const location = useLocation();
  const [open2, setOpen2] = useState(true);
  const [userTenant, setUserTenant] = useState(null);

  useEffect(() => {
    fetchCoachAttendance();
  }, []);

  const fetchCoachAttendance = async () => {
    const res = await getCoachAttendance(location.state?.user?.id);
    if (res) {
      setUserTenant(res);
    }
  };

  function StaffProfile() {
    const location = useLocation();
    const [userData, setUserData] = useState(null);

    useEffect(() => {
      setUserData(location.state?.user || null);
    }, [location.state]);

    // const userData = location.state?.user || null;

    // Prepare personal detail items dynamically
    const personalDetail = [
      { title: "Name", subtitle: userData?.name || "-" },
      { title: "Age", subtitle: userData?.age || "-" },
      { title: "Mobile No", subtitle: userData?.contactPhone || "-" },
      { title: "Email", subtitle: userData?.email || "-" },
      { title: "Skill", subtitle: userData?.coachSkill || "-" },
      { title: "Experience", subtitle: userData?.experience || "-" },
      { title: "Qualification", subtitle: userData?.qualification || "-" },
    ];

    return (
      <>
        <div className="row">
          <div className="col-xl-11 col-xxl-12 col-lg-12">
            <div className="row">
              <div className="col-lg-12">
                <div className="card overflow-hidden">
                  <div
                    className="text-center p-3 overlay-box"
                    style={{ backgroundImage: `url(${IMAGES.BigImg1})` }}
                  >
                    <div className="profile-photo"></div>
                    <h3 className="mt-3 mb-1 text-white">
                      {userData?.name || "-"}
                    </h3>
                    <p className="text-white mb-0">Coach</p>
                  </div>
                  <div className=" row">
                    {personalDetail?.map((data, index) => (
                      <div
                        key={index}
                        className="list-group-item d-flex justify-content-between col-md-6 col-6"
                      >
                        <span className="mb-0">{data.title}</span>{" "}
                        <strong className="text-muted">{data.subtitle}</strong>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="page-titles d-flex justify-content-between align-items-center">
        <h4 className="mb-0">About Coach</h4>
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item ">
            <Link to="/admin/all-coaches">Coach</Link>
          </li>
          <li className="breadcrumb-item active">
            <Link
              onClick={(e) => e.preventDefault()}
              to="#"
              style={{
                pointerEvents: "none",
                color: "inherit",
                color: "#6F77F8",
              }}
            >
              About Coach
            </Link>
          </li>
        </ol>
      </div>
      <StaffProfile />

      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`} onClick={() => setOpen2(!open2)}>
              <div className="cpa">
                <i className="fa-solid fa-file-lines me-2" />
                Coach Attendance
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body py-3">
                  <div className="table-responsive order-list-table">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table className="table table-responsive-lg  table-condensed flip-content">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Session</th>
                            <th>Session Time</th>
                            <th>CheckIn</th>
                            <th>CheckOut</th>
                            <th>Total Hours</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {userTenant?.map((item, ind) => (
                            <tr key={ind}>
                              <td>{ind + 1}</td>
                              <td>{item?.session?.name}</td>
                              <td>
                                {item?.session?.startTime} -
                                {item?.session?.endTime}
                              </td>
                              <td>
                                {item?.checkInTime
                                  ? new Date(item?.checkInTime).toLocaleString()
                                  : ""}
                              </td>
                              <td>
                                {item?.checkOutTime
                                  ? new Date(
                                      item?.checkOutTime
                                    ).toLocaleString()
                                  : ""}
                              </td>
                              <td
                                style={{
                                  color:
                                    item?.totalHours === 0
                                      ? "#ff3b30" // red
                                      : item?.totalHours < 4
                                      ? "#ff9500" // orange
                                      : "#34c759", // green
                                  fontWeight: "600",
                                }}
                              >
                                {formatHoursMinutes(item?.totalHours)}
                              </td>
                              <td>{item?.attendenceStatus}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutCoach;
